import UserVoiceSuggestion from 'owa-service/lib/contract/UserVoiceSuggestion';
import { makePostRequest } from 'owa-ows-gateway/lib/makeServiceRequest';
import { getGuid } from 'owa-guid';
import InferredEntityIds from '../store/schema/InferredEntityIds';
import {
    GRIFFIN_REQUEST_BASEURL,
    POST_NEW_USER_VOICE_SUGGESTION,
} from '../helpers/GriffinConstants';
import { format } from 'owa-strings';

export default function postUserVoiceSuggestionAction(
    suggestion: UserVoiceSuggestion,
    inferredEntityIds: InferredEntityIds
): Promise<Response> {
    const requestBody = {
        ...suggestion,
        ...inferredEntityIds,
    };

    return makePostRequest(
        format(GRIFFIN_REQUEST_BASEURL, POST_NEW_USER_VOICE_SUGGESTION),
        requestBody,
        getGuid(),
        true /*returnFullResponse*/,
        null /*customHeaders*/,
        null /*throwServiceError*/,
        true /*sendPayloadAsBody*/
    );
}
